interface FilterSidebarProps {
  type: string;
  region: string;
  year: string;
  genre: string;
  onChange: (key: string, value: string) => void;
  onReset: () => void;
}

const typeOptions = ["全部", "电影", "电视剧"];
const regionOptions = ["全部", "国产", "日韩", "欧美"];
const yearOptions = ["全部", "近5年", "5年以上"];
const genreOptions = [
  "全部",
  "爱情",
  "喜剧",
  "都市",
  "悬疑",
  "青春",
  "科幻",
  "武侠",
  "灾难",
  "家庭",
  "犯罪",
  "动作",
];

interface GroupProps {
  title: string;
  options: string[];
  value: string;
  field: string;
  onChange: (key: string, value: string) => void;
}

function FilterGroup({ title, options, value, field, onChange }: GroupProps) {
  return (
    <div className="py-4 border-b border-background-200/70 last:border-b-0">
      <h3 className="font-heading font-semibold text-sm text-foreground-800 mb-3">
        {title}
      </h3>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = value === option;
          return (
            <button
              key={option}
              type="button"
              onClick={() => onChange(field, option)}
              className={
                active
                  ? "px-3 py-1.5 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-sm cursor-pointer whitespace-nowrap"
                  : "px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-sm hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
              }
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterSidebar({
  type,
  region,
  year,
  genre,
  onChange,
  onReset,
}: FilterSidebarProps) {
  return (
    <div className="rounded-lg bg-background-100 border border-background-200/70 p-4 md:p-5 lg:sticky lg:top-24">
      <div className="flex items-center justify-between">
        <h2 className="font-heading font-semibold text-base text-foreground-950 flex items-center gap-2">
          <i className="ri-filter-3-line text-primary-600"></i>
          筛选条件
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          重置
        </button>
      </div>

      <FilterGroup title="类型" options={typeOptions} value={type} field="type" onChange={onChange} />
      <FilterGroup title="地区" options={regionOptions} value={region} field="region" onChange={onChange} />
      <FilterGroup title="年份" options={yearOptions} value={year} field="year" onChange={onChange} />
      <FilterGroup title="题材" options={genreOptions} value={genre} field="genre" onChange={onChange} />
    </div>
  );
}